module.exports = __webpack_public_path__ + "4be31bf5.webp";